export const Paths = {
  index: "/",
  main: "/main",
  miss: "/miss",
  complete: "/complete",
};